<template>
  <div>
    <div class="sideByDiv">
      <Input placeholder="Port Code" :isRequired="true" :inputValue.sync="data.portCode" :isDisabled="data.disabledPortCode" />
      <CheckBox title="Active" :isChecked.sync="data.portActive" style="padding-left: 10px;" :isDisabled="data.viewMode" />
    </div>
    <Input placeholder="Port Location" :isRequired="true" :inputValue.sync="data.portLocation" :isDisabled="data.viewMode" />
    <InputQuery placeholder="Country Code" :isRequired="true" :items="data.countryCodeItems" itemKey="Country Code" descKey="Country"
                :selectedObject.sync="data.selectedCountryCode" :isDisabled="data.viewMode" />
    <GmapLocation popupMap="popupPort" :data="data" :isGeofence="false" :viewMode="data.viewMode" />
  </div>
</template>

<script>
/* eslint-disable */
import Input from '@/components/Input.vue';
import InputQuery from '@/components/InputQuery.vue';
import GoogleMap from '@/components/GoogleMap.vue';
import CheckBox from '@/components/CheckBox.vue';
import GmapLocation from '@/components/GmapLocation.vue';

export default {
  components: {
    Input, InputQuery, GoogleMap, CheckBox, GmapLocation,
  },
  props: {
		data: { type: Object, default: function () { return {} } }
  },
  methods: {

  },
  mounted() {
  },
  watch: {
    data: {
      deep: true,
      handler(val) {
        //console.log(val);
      }
    },
  }
}
</script>

<style lang="scss" scoped>
@import '@/css/all.scss';

.sideByDiv {
  display: flex;
  flex-direction: row;
}

/*#portGMap {
  padding-top: 10px;
  height: 380px;
  width: 100%;
}*/

</style>
